import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import { colors } from "UI/colors";

export function useAccentColor() {
  const { state } = useManageMyGivingPage();
  const colorCode = state?.pageSettings?.accentColor;

  if (!colorCode) {
    return colors.fnBlue;
  }

  return `#${colorCode}`;
}
